export const hardFailStatuses = [400, ...Array.from({ length: 98 }, (_, i) => i + 402)]
export const networkErrorStatuses = [0, 502, 503, 504]
